import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";


export const Marc21DisplayClientManager = (function($) {

	var restUrl = LS2PAC_CONSTANTS.restUrls.fullDetails;

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecord, function(event) {
		onGetFullDetailsFromMarcRecord(event);
	});

	var onGetFullDetailsFromMarcRecord = function(event) {
		var resource = event.resource;

		if(!resource.details) {
			TLCRest.jsonCall(restUrl + resource.id, {
				callback: function(details) {
					$.each(details, function (index, detailsSection) {
						detailsSection.label = ApplicationData.language[detailsSection.label] || detailsSection.label;
					});

					resource.details = details;
					TLCLogger.log("details", details);
					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecordResponse, {success: true, details: details});
				},
				cache: false
			});
		} else {
			TLCLogger.log("already had details", resource.details);
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecordResponse, {success: true, details: resource.details});
		}

	};

	return {
		setUrl: function( newUrl ) {
			restUrl = newUrl;
		}
	};

})(jQuery);
